<!-- @format -->

@if (favoritesEnabled()) {
	<shared-components-auth-snackbar [location]="FavoritesLocationEnum.PDP"></shared-components-auth-snackbar>
}

<ng-template #aboveTheFoldTemplate>
	<pdp-product-image-carousel
		[location]="dynamicTemplateToLoad()"
		[product]="product"
		[chainIdentifierAbbr]="chainIdentifierAbbr"
		[swatchColor]="defaultColor"
		[defaultCustomizedUrls]="
			(myCustomizerMap$ | async)?.imageURLs
		"></pdp-product-image-carousel>
</ng-template>
@if (useAboveTheFoldMobileContainer() && dynamicTemplateToLoad() !== 'pdp_hybrid_pla') {
	<div class="hmf-display-md-none">
		<div
			class="carousel-initial-styles-{{ dynamicTemplateToLoad() }}"
			[class.is-pla-placeholder]="isPLAPlaceholderEnabled() && isPLA() && isPLAEnabled()"
			[ngClass]="{
				'is-pla': isSSRPLAEnabled() && isPLAEnabled() && isPLA() && !isPLADSCarouselEnabled()
			}">
			<ng-container #aboveTheFoldViewRef></ng-container>
		</div>
	</div>
}

<div
	id="pdp-container"
	#templateOutlet></div>
